exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".endorsement {\n  padding: 3em 0; }\n  .endorsement-body {\n    margin: 0 auto;\n    width: 800px;\n    vertical-align: top; }\n    @media (max-width: 799px) {\n      .endorsement-body {\n        width: 100%;\n        padding: 20px; } }\n    .endorsement-body p {\n      font-style: italic; }\n  .endorsement-author {\n    margin-top: 1em;\n    font-weight: bold;\n    font-size: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/modules/endorsement/endorsement.scss
// module id = ../../../../../src/app/modules/endorsement/endorsement.scss
// module chunks = 0